import AttributeLookupResourceModel from '../../generated/types/model/resource/AttributeLookupResourceModel';

export default class AttributeLookupResourceViewModel extends AttributeLookupResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
